import z from "zod";
import { RequestBuilder } from "../requestBuilder";
import { SyncSchema } from "./syncClient.types";

export const SyncRequestConfig = new RequestBuilder({
  // bodySchema: z.object({
  //   lastModified: z.string().optional(),
  // }),
  path: () => "/sync",
  responseSchema: SyncSchema,
});
